/**
 * Empresa ativa escolhida pelo usuário. Guardamos só o id (não é segredo);
 * a API SEMPRE confere se o usuário tem vínculo ativo com ela.
 */
const KEY = "cafegestor.empresa";
let current: string | null = null;
const listeners = new Set<() => void>();

function read(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function getActiveCompanyId(): string | null {
  return current ?? (current = read());
}

export function setActiveCompanyId(id: string | null) {
  current = id;
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {
    /* navegador sem armazenamento: segue só em memória */
  }
  listeners.forEach((l) => l());
}

export function subscribeActiveCompany(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
